import { render, staticRenderFns } from "./yearProcent.vue?vue&type=template&id=38370e2c&"
import script from "./yearProcent.vue?vue&type=script&lang=js&"
export * from "./yearProcent.vue?vue&type=script&lang=js&"
import style0 from "./yearProcent.vue?vue&type=style&index=0&id=38370e2c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports